<template>
    <div id="loginComponent">
        <div class="login-form-box mt-5">
            <h2>Логин</h2>
            <h4 class="invalid-feedback" v-if="IS_FAIL">Ошибка авторизации</h4>
            <form @submit.prevent="handleSubmit" class="mt-3">
                <div class="form-group">
                    <label for="login">Имя пользователя</label>
                    <input type="text" v-model="login" name="login" ref="login" class="form-control" :class="{ 'is-invalid': submitted && !login }" />
                    <div v-show="submitted && !login" class="invalid-feedback">Имя обязательно</div>
                </div>
                <div class="form-group">
                    <label htmlFor="password">Пароль</label>
                    <input type="password" v-model="password" name="password" class="form-control" :class="{ 'is-invalid': submitted && !password }" />
                    <div v-show="submitted && !password" class="invalid-feedback">Пароль обязательний</div>
                </div>
                <div class="align-center form-group">
                    <button class="btn btn-primary">
                        <span v-if="!IS_LOAD">Логин</span>
                        <section v-if="IS_LOAD">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Логин...
                        </section>
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    // import { mapState, mapActions } from 'vuex'
    import {createNamespacedHelpers} from "vuex";

    const { mapGetters, mapActions} = createNamespacedHelpers('login');

    export default {
        name: "login",
        data () {
            return {
                login: '',
                password: '',
                submitted: false,
                isLoad: false,
                name: ''
            }
        },
        computed: {
            ...mapGetters(['LOGIN', 'PASSWORD', 'IS_FAIL', 'IS_LOAD']),
        },
        created () {
            // reset login status
            // this.logout();
        },
        methods: {
            ...mapActions(['SEND_LOGIN']),
            handleSubmit () {
                localStorage.name = 'NAME';
                this.submitted = true;
                if (this.login && this.password) {
                    this.$store.commit('login/LOGIN', this.login);
                    this.$store.commit('login/PASSWORD', this.password);
                    this.SEND_LOGIN({th: this});
                }
            }
        },
        mounted() {
            if (localStorage.authToken) {
                this.$store.commit('setIsLogin', true);
                this.$store.commit('setName', localStorage.name);
                this.$store.commit('setSecondName', localStorage.secondName);
                this.$store.commit('setAuthToken', localStorage.authToken);
                this.$store.commit('setAllowSection', localStorage.allowSection);
            }
        }
    }
</script>

<style scoped>
    #loginComponent {
        text-align: center;
    }
    #loginComponent .login-form-box {
        display: inline-block;
        width: 20%;
    }
    #loginComponent form {
        text-align: left;
    }
    #loginComponent .align-center {
        text-align: center;
    }
    #loginComponent .invalid-feedback {
        display: inline;
        font-size: 1em;
    }
</style>